/* eslint-disable */
(function () {
  "use strict";
  var polyfillsLoaded = false;
  var whenLoadedFns = [];
  var allowUpgrades = false;
  var flushFn;
  function fireEvent() {
    window.WebComponents.ready = true;
    document.dispatchEvent(
      new CustomEvent("WebComponentsReady", { bubbles: true })
    );
  }
  function batchCustomElements() {
    if (window.customElements && customElements.polyfillWrapFlushCallback) {
      customElements.polyfillWrapFlushCallback(function (flushCallback) {
        flushFn = flushCallback;
        if (allowUpgrades) {
          flushFn();
        }
      });
    }
  }
  function asyncReady() {
    batchCustomElements();
    ready();
  }
  function ready() {
    if (window.HTMLTemplateElement && HTMLTemplateElement.bootstrap) {
      HTMLTemplateElement.bootstrap(window.document);
    }
    polyfillsLoaded = true;
    runWhenLoadedFns().then(fireEvent);
  }
  function runWhenLoadedFns() {
    allowUpgrades = false;
    var done = function () {
      allowUpgrades = true;
      whenLoadedFns.length = 0;
      flushFn && flushFn();
    };
    return Promise.all(
      whenLoadedFns.map(function (fn) {
        return fn instanceof Function ? fn() : fn;
      })
    )
      .then(function () {
        done();
      })
      .catch(function (err) {
        console.error(err);
      });
  }
  window.WebComponents = window.WebComponents || {
    ready: false,
    _batchCustomElements: batchCustomElements,
    waitFor: function (waitFn) {
      if (!waitFn) {
        return;
      }
      whenLoadedFns.push(waitFn);
      if (polyfillsLoaded) {
        runWhenLoadedFns();
      }
    },
  };
  var name = "webcomponents-loader.js";
  var polyfills = [];
  if (
    !(
      "attachShadow" in Element.prototype && "getRootNode" in Element.prototype
    ) ||
    (window.ShadyDOM && window.ShadyDOM.force)
  ) {
    polyfills.push("sd");
  }
  if (!window.customElements || window.customElements.forcePolyfill) {
    polyfills.push("ce");
  }
  var needsTemplate = (function () {
    var t = document.createElement("template");
    if (!("content" in t)) {
      return true;
    }
    if (!(t.content.cloneNode() instanceof DocumentFragment)) {
      return true;
    }
    var t2 = document.createElement("template");
    t2.content.appendChild(document.createElement("div"));
    t.content.appendChild(t2);
    var clone = t.cloneNode(true);
    return (
      clone.content.childNodes.length === 0 ||
      clone.content.firstChild.content.childNodes.length === 0
    );
  })();
  if (
    !window.Promise ||
    !Array.from ||
    !window.URL ||
    !window.Symbol ||
    needsTemplate
  ) {
    polyfills = ["sd-ce-pf"];
  }
  if (polyfills.length) {
    var script = document.querySelector('script[src*="' + name + '"]');
    var newScript = document.createElement("script");
    var replacement = "webcomponents-" + polyfills.join("-") + ".js";
    var url = script.src.replace(name, replacement);
    newScript.src = url;
    if (document.readyState === "loading") {
      newScript.setAttribute(
        "onload",
        "window.WebComponents._batchCustomElements()"
      );
      document.write(newScript.outerHTML);
      document.addEventListener("DOMContentLoaded", ready);
    } else {
      newScript.addEventListener("load", function () {
        asyncReady();
      });
      newScript.addEventListener("error", function () {
        throw new Error("Could not load polyfill bundle" + url);
      });
      document.head.appendChild(newScript);
    }
  } else {
    polyfillsLoaded = true;
    if (document.readyState === "complete") {
      fireEvent();
    } else {
      window.addEventListener("load", ready);
      window.addEventListener("DOMContentLoaded", function () {
        window.removeEventListener("load", ready);
        ready();
      });
    }
  }
})();
